export enum AudienceSaveErrorSource {
	AddEmailTemplate = 1,
	UpdateEmailTemplate = 2,
	UpdateDistributionHierarchy = 3,
}
